import { Avatar as BaseAvatar } from '@base-ui/react/avatar';
import type * as React from 'react';
import { cn } from '@/lib/utils';

export function Avatar({ className, ...props }: React.ComponentProps<typeof BaseAvatar.Root>) {
  return <BaseAvatar.Root className={cn('relative flex size-10 shrink-0 overflow-hidden', className)} {...props} />;
}

export function AvatarImage({ className, ...props }: React.ComponentProps<typeof BaseAvatar.Image>) {
  return <BaseAvatar.Image className={cn('aspect-square size-full', className)} {...props} />;
}

export function AvatarFallback({ className, ...props }: React.ComponentProps<typeof BaseAvatar.Fallback>) {
  return (
    <BaseAvatar.Fallback
      className={cn('flex size-full items-center justify-center bg-mesa-cream-dark', className)}
      {...props}
    />
  );
}
